import React from 'react';
interface ToggleProps {
  label: string;
  checked: boolean;
  onChange: (value: boolean) => void;
  hideLabelOnMobile?: boolean;
}
export function Toggle({
  label,
  checked,
  onChange,
  hideLabelOnMobile = false
}: ToggleProps) {
  return <button type="button" role="switch" aria-checked={checked} aria-label={label} onClick={() => onChange(!checked)} className="inline-flex items-center gap-2.5 whitespace-nowrap rounded-full py-1 text-[13px] font-medium text-ink-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/60" data-id="element-1391" data-mp="17x40v0ar69i0">
      <span className={`relative h-5 w-9 rounded-full transition-colors duration-150 ${checked ? 'bg-accent' : 'bg-white/15'}`} data-id="element-1392" data-mp="p7fis7s02nk2">
        <span className={`absolute top-0.5 h-4 w-4 rounded-full shadow transition-transform duration-150 ease-snappy ${checked ? 'translate-x-[18px] bg-night-950' : 'translate-x-0.5 bg-ink'}`} data-id="element-1393" data-mp="t9aix8y72uw9" />
      </span>
      <span className={hideLabelOnMobile ? 'hidden sm:inline' : ''} data-id="element-1394" data-mp="rxiz05tfigbo">{label}</span>
    </button>;
}